module.exports = __webpack_public_path__ + "static/media/choice_valid.7e04b76e.mp3";